<template>
  <div class="async-image">
    <transition :name="animation ? 'fade' : ''" :css="animation" class="transition-stub">
      <img
        v-if="loaded && !error"
        :src="src"
        :alt="alt"
        v-bind="_.omit($attrs, ['class'])"
        class="async-image__img"
        :class="contentClass"
        data-cy="async-image"
        @load="handleLoad"
        @error="handleError">
    </transition>
    <slot v-if="error" name="fallback">
      <span class="async-image__fallback">No image</span>
    </slot>
  </div>
</template>

<script>
import { imageExists } from '@/utils/helpers'

export default {
  name: 'CyAsyncImage',
  props: {
    src: {
      type: String,
      required: false,
      default: '',
    },
    alt: {
      type: String,
      default: '',
    },
    animation: {
      type: Boolean,
      default: false,
    },
    contentClass: {
      type: [String, Array],
      default: '',
    },
  },
  emits: ['load'],
  data () {
    return {
      loaded: false,
      error: false,
    }
  },
  watch: {
    src: {
      handler (newSrc, oldSrc) {
        if (newSrc !== oldSrc) {
          this.setImage()
        }
      },
    },
  },
  mounted () {
    this.setImage()
  },
  methods: {
    imageExists,
    setImage () {
      this.loaded = false
      this.error = false
      // first check static images folder
      const localImageExists = this.imageExists(this.src)
      if (localImageExists) {
        this.handleLoad()
      } else {
        const img = new Image()
        img.src = this.src
        img.onload = this.handleLoad
        img.onerror = this.handleError
      }
    },
    setImageExists () {
      this.$emit('load', this.loaded)
    },
    handleLoad () {
      this.error = false
      this.loaded = true
      this.setImageExists()
    },
    handleError () {
      this.error = true
      this.loaded = false
      this.setImageExists()
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.async-image {
  &__img {
    width: 100%;
    height: 100%;
  }
}
</style>
